<template>
  <div
    :class="
      twMerge(
        'chip ease-linear duration-300',
        'hover:bg-teal-50 hover:border-teal-600 hover:text-teal-600',
        'flex justify-center items-center m-1 font-medium py-2 px-4 rounded-full',
        ' text-gray-700 bg-white border border-gray-300',
        'cursor-pointer text-xs',
        variant === 'pill' && 'rounded-full',
        variant === 'tag' && 'rounded-lg',
        variant === 'card' && 'rounded-md text-primary px-2 py-1 chip--card',
        selected && 'bg-teal-50 text-primary border-primary chip--selected',
        selected && selectedClasses,
        classes
      )
    "
    @click="$emit('click')"
  >
    <slot name="prefix"></slot>
    <div class="font-normal leading-tight max-w-full flex-initial">
      <slot></slot>
    </div>
    <slot name="suffix"></slot>
  </div>
</template>
<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

defineEmits(['click'])
const {
  classes = '',
  variant = 'pill',
  // disabled = false, // unused prop
  selected = false,
  selectedClasses = '',
} = defineProps<{
  classes?: string
  variant?: string
  disabled?: boolean
  selected?: boolean
  selectedClasses?: string
}>()
</script>
<style lang="css">
.chip {
  &--card {
    box-shadow: 0 4px 16px 0 rgba(31, 42, 55, 0.06);
    background: rgba(241, 254, 255, 0.9);
    border: none;
  }
}
</style>
